export default "__VITE_ASSET__CW4YljCX__"